const sortByLabel = (a: { label: string }, b: { label: string }): number =>
  a.label.localeCompare(b.label);

export default sortByLabel;
